<div class="payment-method-tab flex" [class.payment-method-tab--active]="active">
  <div class="payment-method-tab-selector"></div>
  <button class="payment-method-tab-button flex">
    <img src="{{ getTypeImage() }}" alt="{{ paymentMethod?.cardName }}" class="payment-method-tab-button__icon" />
    Card ending in {{ paymentMethod?.last4 }}
    {{ paymentMethod?.default ? '(Default)' : '' }}
  </button>
</div>
